import { ForestResearchImage } from './ForestResearchImage';
import { ChemicalResearchImage } from './ChemicalResearchImage';
import { TransportResearchImage } from './TransportResearchImage';
import { FloodResearchImage } from './FloodResearchImage';
import { HighriseResearchImage } from './HighriseResearchImage';

/** Project-authored scene illustrations; no incident/product photography is rendered. */
export function ScenarioCardArt({ id, name }: { readonly id: string; readonly name: string }) {
  if (id === 'high-rise-building-fire')
    return <HighriseResearchImage file="highrise-fire-hero.webp" label={name} />;
  if (id === 'forest-fire')
    return <ForestResearchImage file="forest-wildfire-hero-1600.webp" label={name} />;
  if (id === 'chemical')
    return <ChemicalResearchImage file="00-chemical-incident-hero.png" label={name} />;
  if (id === 'transport')
    return <TransportResearchImage file="hero-traffic-underground.webp" label={name} />;
  if (id === 'flood') return <FloodResearchImage file="00-flood-cover.webp" label={name} />;
  return null;
}
